import React, { useState } from 'react';
import srikanthPhoto from '../assets/SrikanthBandari.png';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    email: '',
    phone: '',
    serviceRequired: '',
    message: ''
  });

  const [formErrors, setFormErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [isLightboxOpen, setIsLightboxOpen] = useState(false);

  // Field Validation
  const validateForm = () => {
    const errors = {};
    if (!formData.name.trim()) {
      errors.name = 'Full Name is required';
    }

    if (!formData.company.trim()) {
      errors.company = 'Company name is required';
    }

    if (!formData.email.trim()) {
      errors.email = 'Email address is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      errors.email = 'Invalid email address';
    }

    if (!formData.phone.trim()) {
      errors.phone = 'Phone number is required';
    } else {
      const cleanPhone = formData.phone.replace(/[^0-9+]/g, '');
      if (cleanPhone.length < 10) {
        errors.phone = 'Phone number must be at least 10 digits';
      }
    }

    if (!formData.serviceRequired) {
      errors.serviceRequired = 'Please select a service requirement';
    }

    return errors;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
    // Clear error
    if (formErrors[name]) {
      setFormErrors({
        ...formErrors,
        [name]: ''
      });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errors = validateForm();
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }

    setIsSubmitting(true);

    // Simulate API request call
    setTimeout(() => {
      setIsSubmitting(false);
      setSubmitSuccess(true);
      setFormData({
        name: '',
        company: '',
        email: '',
        phone: '',
        serviceRequired: '',
        message: ''
      });
    }, 1800);
  };

  return (
    <div className="page-contact">
      {/* HEADER */}
      <section className="section" style={{ paddingBottom: '3rem' }}>
        <div className="section-header">
          <span className="section-tag">Get in Touch</span>
          <h2 className="section-title">Let's Talk About Your Business</h2>
          <p className="section-subtitle" style={{ maxWidth: '750px', margin: '1rem auto 0 auto' }}>
            Have a digital marketing or technology requirement? Tell us about your business and what you want to achieve.
            Our team can help you explore the right digital and technology approach.
          </p>
        </div>
      </section>

      {/* FORM & INFO LAYOUT */}
      <section className="section bg-alt-dark" style={{ borderTop: '1px solid var(--border-color)', paddingTop: '4rem' }}>
        <div className="contact-container" style={{ maxWidth: '1100px', margin: '0 auto' }}>

          {/* SIDE INFORMATION PANEL */}
          <div className="contact-info-panel" style={{ padding: '3.5rem 2.5rem' }}>
            <div className="info-header">
              <h3 style={{ textTransform: 'uppercase', fontFamily: 'var(--font-title)', fontSize: '1.8rem', fontWeight: 800 }}>Saveera Biotech </h3>
              <p style={{ marginTop: '0.5rem', color: 'var(--text-secondary)' }}>Get professional consulting from our technology team and scale your operations.</p>
            </div>

            <ul className="info-list" style={{ margin: '3rem 0' }}>
              <li className="info-item" style={{ alignItems: 'center', gap: '1.5rem' }}>
                <img
                  src={srikanthPhoto}
                  alt="Srikanth Bandari"
                  style={{
                    width: '70px',
                    height: '70px',
                    borderRadius: '50%',
                    objectFit: 'cover',
                    border: '2px solid var(--accent-color)',
                    background: '#f8f9fa',
                    cursor: 'pointer'
                  }}
                  onClick={() => setIsLightboxOpen(true)}
                />
                <div className="info-detail">
                  <h4>Proprietor & HR</h4>
                  <p><strong>Srikanth Bandari</strong></p>
                </div>
              </li>

              <li className="info-item">
              </li>

              <li className="info-item">
                <div className="info-icon">📞</div>
                <div className="info-detail">
                  <h4>Phone Numbers</h4>
                  <p style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem' }}>
                    <a href="tel:+918688334545" style={{ color: 'inherit', textDecoration: 'none', fontWeight: 600 }}>+91 86883 34545</a>
                  </p>
                </div>
              </li>

              <li className="info-item">
                <div className="info-icon">✉️</div>
                <div className="info-detail">
                  <h4>Email Addresses</h4>
                  <p style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem' }}>
                    <a href="mailto:info@saveerabiotech.com" style={{ color: 'inherit', textDecoration: 'none' }}>info@saveerabiotech.com</a>
                    <a href="mailto:hr@saveerabiotech.com" style={{ color: 'inherit', textDecoration: 'none' }}>hr@saveerabiotech.com</a>
                    <a href="mailto:saveeerabiotech.info@gmail.com" style={{ color: 'inherit', textDecoration: 'none' }}>saveeerabiotech.info@gmail.com</a>
                  </p>
                </div>
              </li>

              <li className="info-item">
                <div className="info-icon">📄</div>
                <div className="info-detail">
                  <h4>Udyam Registration</h4>
                  <p>UDYAM-TS-26-0008522</p>
                </div>
              </li>
            </ul>

            <div>
            </div>
          </div>

          {/* FORM PANEL */}
          <div className="contact-form-panel" style={{ padding: '3.5rem 3rem' }}>
            {submitSuccess ? (
              <div className="success-screen">
                <div className="success-icon-circle">✓</div>
                <h3>Start a Conversation!</h3>
                <p>
                  Thank you for submitting your details. A technology advisor from Saveera Biotech will contact you shortly to review your business requirement.
                </p>
                <button className="btn-primary" onClick={() => setSubmitSuccess(false)}>
                  Send Another Inquiry
                </button>
              </div>
            ) : (
              <form onSubmit={handleSubmit} noValidate>
                <h3 style={{ textTransform: 'uppercase', fontFamily: 'var(--font-title)', fontSize: '1.4rem', fontWeight: 800, marginBottom: '2rem' }}>Start a Conversation</h3>

                <div className="form-group-row">
                  {/* Name field */}
                  <div className="form-group">
                    <label htmlFor="name">Name</label>
                    <div className="form-input-wrapper">
                      <input
                        type="text"
                        id="name"
                        name="name"
                        placeholder="John Doe"
                        className={`form-input ${formErrors.name ? 'error' : ''}`}
                        value={formData.name}
                        onChange={handleInputChange}
                      />
                      {formErrors.name && <span className="error-message">{formErrors.name}</span>}
                    </div>
                  </div>

                  {/* Company field */}
                  <div className="form-group">
                    <label htmlFor="company">Company</label>
                    <div className="form-input-wrapper">
                      <input
                        type="text"
                        id="company"
                        name="company"
                        placeholder="Acme Corp"
                        className={`form-input ${formErrors.company ? 'error' : ''}`}
                        value={formData.company}
                        onChange={handleInputChange}
                      />
                      {formErrors.company && <span className="error-message">{formErrors.company}</span>}
                    </div>
                  </div>
                </div>

                <div className="form-group-row">
                  {/* Email field */}
                  <div className="form-group">
                    <label htmlFor="email">Email</label>
                    <div className="form-input-wrapper">
                      <input
                        type="email"
                        id="email"
                        name="email"
                        placeholder="john@example.com"
                        className={`form-input ${formErrors.email ? 'error' : ''}`}
                        value={formData.email}
                        onChange={handleInputChange}
                      />
                      {formErrors.email && <span className="error-message">{formErrors.email}</span>}
                    </div>
                  </div>

                  {/* Phone field */}
                  <div className="form-group">
                    <label htmlFor="phone">Phone</label>
                    <div className="form-input-wrapper">
                      <input
                        type="tel"
                        id="phone"
                        name="phone"
                        placeholder="+91 (120) 000-0000"
                        className={`form-input ${formErrors.phone ? 'error' : ''}`}
                        value={formData.phone}
                        onChange={handleInputChange}
                      />
                      {formErrors.phone && <span className="error-message">{formErrors.phone}</span>}
                    </div>
                  </div>
                </div>

                {/* Service dropdown selection */}
                <div className="form-group">
                  <label htmlFor="serviceRequired">Service Required</label>
                  <div className="form-input-wrapper">
                    <select
                      id="serviceRequired"
                      name="serviceRequired"
                      className={`form-input ${formErrors.serviceRequired ? 'error' : ''}`}
                      value={formData.serviceRequired}
                      onChange={handleInputChange}
                      style={{ background: 'var(--bg-tertiary)', color: formData.serviceRequired ? 'var(--text-primary)' : 'var(--text-muted)' }}
                    >
                      <option value="" disabled>Select a Service...</option>
                      <option value="Digital Marketing">Digital Marketing (SEO, Social, PPC)</option>
                      <option value="IT Consultancy">IT Consultancy (Strategy, Advisory)</option>
                      <option value="Web & Digital Solutions">Web & Digital Solutions (Websites, Apps)</option>
                      <option value="Computer & IT Services">Computer & IT Services (Programming)</option>
                    </select>
                    {formErrors.serviceRequired && <span className="error-message">{formErrors.serviceRequired}</span>}
                  </div>
                </div>

                {/* Message field */}
                <div className="form-group">
                  <label htmlFor="message">Message</label>
                  <textarea
                    id="message"
                    name="message"
                    rows="4"
                    placeholder="Tell us about your digital or technology needs..."
                    className="form-input"
                    value={formData.message}
                    onChange={handleInputChange}
                    style={{ resize: 'vertical' }}
                  />
                </div>

                <button type="submit" className="btn-submit" disabled={isSubmitting} style={{ marginTop: '1rem' }}>
                  {isSubmitting ? (
                    <>
                      <div className="spinner"></div>
                      Submitting...
                    </>
                  ) : (
                    'Submit Inquiry'
                  )}
                </button>
              </form>
            )}
          </div>
        </div>
      </section>

      {/* IMAGE LIGHTBOX MODAL */}
      {isLightboxOpen && (
        <div className="modal-overlay" onClick={() => setIsLightboxOpen(false)} style={{ zIndex: 1100 }}>
          <div
            style={{
              position: 'relative',
              maxWidth: '550px',
              width: '90%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setIsLightboxOpen(false)}
              style={{
                position: 'absolute',
                top: '-45px',
                right: '0',
                background: 'none',
                border: 'none',
                color: 'white',
                fontSize: '2.5rem',
                cursor: 'pointer',
                lineHeight: '1'
              }}
            >
              ×
            </button>
            <img
              src={srikanthPhoto}
              alt="Srikanth Bandari Full View"
              style={{
                width: '100%',
                borderRadius: '12px',
                boxShadow: '0 10px 40px rgba(0,0,0,0.4)',
                border: '4px solid white',
                background: 'white'
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default Contact;
